import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useRevokeTenantApiKey = (companyId?: string) => {
  const queryClient = useQueryClient();

  const queryKey = companyId
    ? ['admin', 'companies', companyId, 'api-keys']
    : ['dev-tools', 'api-keys'];

  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<unknown, Error, string>({
    mutationFn: keyId =>
      api.delete(
        companyId
          ? `admin/companies/${companyId}/api-keys/${keyId}`
          : `dev-tools/api-keys/${keyId}`,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return { revokeKey: mutateAsync, isLoading, error, reset };
};
